/**
 * Env accessors. All values resolved from Vite `import.meta.env` at build time.
 * Local dev: copy `.env.example` → `.env.local`.
 */

interface PortalEnv {
  apiBaseUrl: string;
  functionKey: string;
  b2cTenant: string;
  b2cPolicy: string;
  b2cClientId: string;
  b2cRedirectUri: string;
  b2cPostLogoutRedirectUri: string;
  portalVersion: string;
}

function readEnv(): PortalEnv {
  const env = import.meta.env;
  const apiBaseUrl = (env.VITE_API_BASE_URL as string | undefined)?.replace(/\/+$/, '')
    // Same-origin by default (Bill 2026-09-22): the browser calls
    // portal.mypcb.com/api, Front Door routes it to pcb-retail-portal-api, and
    // the WAF sees every request. An absolute Function URL would bypass it.
    ?? '/api';
  const functionKey = (env.VITE_FUNCTION_KEY as string | undefined) ?? '';
  const b2cTenant = (env.VITE_B2C_TENANT as string | undefined) ?? 'pcbb2c';
  const b2cPolicy = (env.VITE_B2C_POLICY as string | undefined) ?? 'B2C_1A_PCB_EmailOTP_SignUpSignIn';
  const b2cClientId = (env.VITE_B2C_CLIENT_ID as string | undefined) ?? '';
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:53010';
  const b2cRedirectUri = (env.VITE_B2C_REDIRECT_URI as string | undefined) ?? `${origin}/auth/callback`;
  const b2cPostLogoutRedirectUri =
    (env.VITE_B2C_POST_LOGOUT_REDIRECT_URI as string | undefined) ?? `${origin}/`;
  const portalVersion = (env.VITE_PORTAL_VERSION as string | undefined) ?? '0.1.0';

  if (env.PROD) {
    if (!functionKey) {
      // eslint-disable-next-line no-console
      console.warn('[RCP] VITE_FUNCTION_KEY not set — /portal/* calls will 401.');
    }
    if (!b2cClientId) {
      // eslint-disable-next-line no-console
      console.warn('[RCP] VITE_B2C_CLIENT_ID not set — B2C sign-in will fail.');
    }
  }

  return {
    apiBaseUrl,
    functionKey,
    b2cTenant,
    b2cPolicy,
    b2cClientId,
    b2cRedirectUri,
    b2cPostLogoutRedirectUri,
    portalVersion,
  };
}

export const ENV: PortalEnv = readEnv();
